@if (link(); as link) {
  <!-- Laid out like app-attachment-card's download button, so both kinds of file read the same in the timeline -->
  <a
    class="flex items-center justify-start text-left no-underline cursor-pointer group focus-visible:outline-none"
    [ngClass]="{ '!cursor-default pointer-events-none': previewMode() }"
    [attr.href]="previewMode() ? null : link.webUrl"
    target="_blank"
    rel="noopener noreferrer"
    [attr.tabindex]="currentTabIndex()"
    [attr.aria-label]="
      'cl_chat.oneDriveOpenFile' | translate: { fileName: link.name, size: size() || ('cl_chat.unknown' | translate) }
    "
    data-e2e="cloud-file-card"
  >
    <mi-attachment-icon [attachmentName]="link.name"> </mi-attachment-icon>
    <div
      #nameEl
      [pTooltip]="nameEl.scrollWidth > nameEl.clientWidth ? link.name : ''"
      tooltipPosition="top"
      class="font-bold inline-block text-base text-color ml-3 mr-5.5 break-words w-[143px] ellipsis-overflow"
      [ngClass]="{ 'my-content': isMine() }"
      data-e2e="cloud-file-name"
    >
      {{ link.name }}
      <div
        class="h-[22px] pt-[5px] text-sm text-color font-semibold"
        [ngClass]="{
          'my-content': isMine(),
          'group-hover:hidden group-focus-within:hidden': !previewMode()
        }"
      >
        <i class="mi2-shared text-sm" aria-hidden="true"></i>
        <span>OneDrive{{ size() ? ' · ' + size() : '' }}</span>
      </div>
      @if (!previewMode()) {
        <div
          class="pt-[5px] hidden h-[22px] text-sm text-primary w-max group-hover:block group-focus-within:block group-focus-visible:[&>*]:shadow-[0_0_0_1px_var(--p-primary-color)] group-focus-visible:[&>*]:rounded-[2px]"
          [ngClass]="{ 'my-content': isMine() }"
        >
          <i class="mi2-shared text-sm" aria-hidden="true"></i>
          <span>{{ 'cl_chat.oneDriveOpen' | translate }}</span>
        </div>
      }
    </div>
  </a>
} @else {
  <span class="content" [ngClass]="{ 'my-content': isMine() }" [innerHTML]="item()?.fallbackText | linky"></span>
}
